import { useEffect, useState } from "react"

export const useIsStuck = (refs: React.RefObject<HTMLElement>[]): boolean => {
  const [isStuck, setIsStuck] = useState<boolean>(false)

  useEffect(() => {
    const checkIsStuck = () => {
      const stuck = refs.some((ref) => {
        if (!ref.current) return false
        const rect = ref.current.getBoundingClientRect()
        const computedStyles = getComputedStyle(ref.current)
        const isVisible = computedStyles.display === "flex"
        const elementTop = Number.parseInt(computedStyles.top, 10)
        return rect.top <= elementTop && isVisible
      })
      setIsStuck(stuck)
    }

    checkIsStuck()

    if (globalThis) {
      globalThis.addEventListener("scroll", checkIsStuck)
    }
    return () => {
      globalThis.removeEventListener("scroll", checkIsStuck)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return isStuck
}
